module.exports = __webpack_public_path__ + "img/b1.4cacd9a.jpg";